import { createElement } from "react";
import React from "react";
import { equals, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { Localization_Language } from "../Shared/Shared.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";

function Components_container_CFBB04B(selected, child, onClick) {
    return createElement("div", {
        style: createObj(toList(delay(() => append(singleton(["cursor", "pointer"]), delay(() => append(singleton(["textAlign", "center"]), delay(() => append(singleton(["padding", 5 + "px"]), delay(() => append(singleton(["borderRadius", 20 + "px"]), delay(() => append(singleton(["minWidth", 10 + "ch"]), delay(() => (selected ? singleton(["backgroundColor", "rgba(98, 181, 229, 1)"]) : empty())))))))))))))),
        onClick: (_arg) => {
            onClick();
        },
        children: child,
    });
}

export function Components_LanguageSwitch() {
    let elems;
    const ctx = reactApi.useContext(ctx_1);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#FFFFFF",
        color: "#000000",
        borderRadius: 20 + "px",
        fontSize: 0.8 + "rem",
        padding: ((((((5 + "px") + " ") + (5 + "px")) + " ") + (5 + "px")) + " ") + (5 + "px"),
    }], (elems = [Components_container_CFBB04B(equals(ctx.Language, new Localization_Language(0, [])), createElement("span", {
        className: join(" ", toList(delay(() => append(singleton("switch-text"), delay(() => (equals(ctx.Language, new Localization_Language(0, [])) ? singleton("selected") : empty())))))),
        children: "Norsk",
    }), () => {
        ctx.SetLanguage(new Localization_Language(0, []));
    }), Components_container_CFBB04B(equals(ctx.Language, new Localization_Language(1, [])), createElement("span", {
        className: join(" ", toList(delay(() => append(singleton("switch-text"), delay(() => (equals(ctx.Language, new Localization_Language(1, [])) ? singleton("selected") : empty())))))),
        children: "English",
    }), () => {
        ctx.SetLanguage(new Localization_Language(1, []));
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

